import { render, staticRenderFns } from "./interventiondetailtech.vue?vue&type=template&id=338ed1fd&scoped=true&"
import script from "./interventiondetailtech.vue?vue&type=script&lang=js&"
export * from "./interventiondetailtech.vue?vue&type=script&lang=js&"
import style0 from "./interventiondetailtech.vue?vue&type=style&index=0&id=338ed1fd&lang=scss&scoped=true&"
import style1 from "./interventiondetailtech.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "338ed1fd",
  null
  
)

export default component.exports